module.exports = __webpack_public_path__ + "static/media/blogpost-cards.009564ca.jpg";